<h6 class="loginHeadingText text-start pt-2">EVENT DETAILS</h6>
<div class="row mb-12px">
    <div class="col-md-2 pe-0 align-self-center">
        <label for="" class="required">EVENT TITLE</label>
    </div>
    <div class="col-md-10">
        <input type="text" class="form-control" maxlength="1000" [disabled]="disableAfterReview" [(ngModel)]="selectedGenInfoSpProject.projectTitle" (ngModelChange)="onAnyFieldValueChange($event)"a maxlength="499">
    </div>
</div>

<!-- <div class="row mb-12px">
    <div class="col-md-2 pe-0 align-self-center">
        <label for="">PWR REQUEST#</label>
    </div>
    <div class="col-md-10">
        <div class="row">
            <div class="col-md-5">
                <input type="text" class="form-control" maxlength="200" [disabled]="!enablePWR"  [(ngModel)]="selectedGenInfoSpProject.pwrNumber">
            </div>
            <div class="col-md-2 align-self-center px-0">
                
            </div>
            <div class="col-md-5">
                
            </div>
        </div>
    </div>
</div> -->

<div class="row mb-12px">
    <div class="col-md-2 pe-0 align-self-center">
        <label for="" class="">ISO SPOC</label>
    </div>
    <div class="col-md-10">
        <div class="row">
            <div class="col-md-5">
                <select class="form-select" aria-label="Default select example" [disabled]="disableAfterReview" [(ngModel)]="selectedSreSpoc" (ngModelChange)="onAnyFieldValueChange($event)" (change)="onSelectedSreSpoc()">
                    <option selected="" value="0">Select SPOC</option>
                    <option *ngFor="let item of sreUsers" [value]="item.userID">
                        {{ item.firstname + " " +  item.lastname}}
                    </option>
                </select>
            </div>    
            <div class="col-md-2 px-0 align-self-center">
                <label for="">RETAIL OFFER</label>
            </div>
            <div class="col-md-5">
                <input type="text" class="form-control" maxlength="200" [disabled]="disableAfterReview"  [(ngModel)]="selectedGenInfoSpProject.retailOffer" maxlength="99">
            </div>       
        </div>
    </div>
</div>
<div class="row mb-12px">
    <div class="col-md-2 pe-0 align-self-center">
        <label for="">EVENT ID</label>
    </div>
    <div class="col-md-10">
        <div class="row">
            <div class="col-md-5">
                <input type="text" class="form-control" maxlength="200" [disabled]="disableAfterReview == false? eventIdDisable: disableAfterReview" [(ngModel)]="selectedGenInfoSpProject.eventId" (ngModelChange)="onAnyFieldValueChange($event)" maxlength="99">
            </div>
            <div class="col-md-2 px-0 align-self-center">
                <label for="">LOCATION</label>
            </div>
            <div class="col-md-5">
                <!-- <input type="text" class="form-control" maxlength="200" [disabled]="disableAfterReview" [(ngModel)]="selectedGenInfoSpProject.location"  maxlength="99"> -->
                <select class="form-select" aria-label="Default select example" [disabled]="disableAfterReview" [(ngModel)]="selectedLocation" (change)="onSelectedLocation()" [(ngModel)]="selectedGenInfoSpProject.location" (ngModelChange)="onAnyFieldValueChange($event)">
                    <option selected="" value="0">Select Location</option>
                    <option *ngFor="let item of locations" [value]="item.locationId">
                        {{ item.locationName }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</div>

<div class="row mb-12px">
    <div class="col-md-2 pe-0 align-self-center">
        <label for="">MABD</label>
    </div>
    <div class="col-md-10">
        <div class="row">
            <div class="col-md-5">
                <p-calendar dateFormat="dd-M-yy" [disabled]="disableAfterReview" [style]="{'width':'100%','margin-top':'3px'}"
                (ngModelChange)="onMadbDateChange($event)"  
                [(ngModel)]="madbDate"> </p-calendar>
            </div>
            <div class="col-md-2 align-self-center px-0">
                <label for="">DISPLAY TYPE</label>
            </div>
            <div class="col-md-5">
                <select class="form-select" aria-label="Default select example" [disabled]="disableAfterReview" [(ngModel)]="selectedDisplayType" (change)="onSelectedDisplayType()">
                    <option selected="" value="0">Select Display Type</option>
                    <option *ngFor="let item of displayTypes" [value]="item.displayID">
                        {{ item.displayName }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</div>
<div class="row mb-12px">
    <div class="col-md-5 pe-0 align-self-center">
        <label for="">PRODUCT FLOW AND REPLENISHMENT</label>
    </div>
    <div class="col-md-7">
        <!-- <div class="row">
            <div class="col-md-10">                -->
                <p-multiSelect [options]="productFLowsList" [disabled]="disableAfterReview" [(ngModel)]="selectedGenInfoSpProject.productFLowList" optionLabel="productFlowDescription" [showHeader]="true"
                    [filter]="true" placeholder="Select ProductFlow" dataKey="productFlowID"
                    (ngModelChange)="onSelectedProductFLow($event)" class="custom-multiselect-1"></p-multiSelect>
            <!-- </div>
        </div> -->
    </div>
</div>
